

















































































































































































import {forEach, pick, values} from 'lodash'
import {DateTime} from 'luxon'
import {Component, Vue, Prop, Watch, Ref} from 'vue-property-decorator'
import {namespace} from 'vuex-class'

import PageHeader from '@/components/PageHeader.vue'
import PageFooter from '@/components/PageFooter.vue'
import {
  LogEventWidthGroupsPayload,
  BizPropertyPayload, UserPropertyPayload,
} from '@/store/modules/gtm/types'
import {Company} from '@/store/modules/companies/types'
import isBizRNum from '@/validate/is-biz-r-num'
import isCorpRNum from '@/validate/is-corp-r-num'
import isPersonRNum from '@/validate/is-person-r-num'
import {showChannelTalk} from '@/utils'

import RequestNewTokenModal from './RequestNewTokenModal.vue'
import DuplicationModal from './DuplicationModal.vue'

// Company는 회사 검색 API 응답 타입.
// _applyCompany는 검색 결과 / 직접입력(null) / 외부 prefill(부분 객체) 모두 받으므로 Partial.
// ownerRegistrationNumber는 현재 Company에 없지만 추후 API가 내려주게 될 가능성 대비
// 옵셔널로 추가 — 이 필드가 정식 추가될 때 _applyCompany 수정 필요성을 코드로 환기시킨다.
type CompanyFormSeed = Partial<Company> & {
  ownerRegistrationNumber?: string | null
}

const layout = namespace('layout')
const companies = namespace('companies')
const biz = namespace('biz')
const auth = namespace('auth')
const gtm = namespace('gtm')

interface Errors {
  name: boolean
  bizRegistrationNumber: boolean
  corporateRegistrationNumber?: boolean
  ownerName?: boolean
  ownerRegistrationNumber?: boolean
  bizPhoneNumber?: boolean
  ownerEmail?: boolean
}

@Component({
  components: {PageHeader, PageFooter, RequestNewTokenModal, DuplicationModal}
})
export default class BizPage extends Vue {
  @Prop({default: 0, type: Number}) windowScrollY: number

  nextActionText: string[] = ['입력 완료', '확인 완료']
  step: number = 0
  validate: any = {}
  doNext: boolean = true

  errors: Errors = {
    name: true,
    bizRegistrationNumber: true,
    corporateRegistrationNumber: true,
    ownerName: true,
    ownerRegistrationNumber: true,
    bizPhoneNumber: true,
    ownerEmail: true,
  }
  searchKeyword: string | null = ''
  selectedCompany = null as any
  selectedIndex: number | null = null
  name: string | null = null
  bizRegistrationNumber = ''
  corporateRegistrationNumber = ''
  ownerName = ''
  ownerRegistrationNumber = ''
  bizPhoneNumber = ''
  ownerEmail = ''
  isDuplicatedBiz = false

  searchCompanyStatus: string = 'pending'
  loading: boolean = false
  sending: boolean = false

  checkBizExistsStatus: 'pending' | 'failed' | 'success' | 'loading' = 'pending'

  @layout.Mutation('updateError') updateError
  @companies.Action('getCompanies') getCompanies
  @companies.State('companies') companies
  @companies.Mutation('clear') clearCompanies
  @biz.Action('createBiz') createBiz
  @biz.State('id') bizId
  @biz.State('bizs') bizs
  @biz.Getter('firstBizId') firstBizId
  @biz.Action('checkBizExists') checkBizExists: (payload: {registrationNumber: string}) => Promise<boolean>
  @auth.State('id') userId
  @auth.State('name') userName
  @auth.State('email') email
  @auth.State('phone') phone
  @auth.Action('getUser') getUser
  @auth.Action('signOut') signOut
  @gtm.Action('logEventWithGroups') logEventWithGroups: (payload: LogEventWidthGroupsPayload) => void
  @gtm.Action('setBizProperty') setBizProperty: (payload: BizPropertyPayload) => void
  @gtm.Action('setUserProperty') setUserProperty: (payload: UserPropertyPayload) => void

  @Ref('formData') formData: any

  specialChars = /[`~!@#$%^&*()_|+\-=?;:'",.<>\\{\\}\\[\]\\/]/gi

  @Watch('searchKeyword', {immediate: true})
  __searchKeyword(value) {
    if(!value) {
      this.searchCompanyStatus = 'pending'
    } 
    if(this.companies.length > 0) {
      this.clearCompanies()
    }
    this.searchKeyword = value.replace(this.specialChars, '')
  }

  get type(): string {
    return this.$route.name || 'sign-up-biz'
  }

  get pageHeaderClass() {
    return {
      'is-sign-up': this.$route.name === 'sign-up-biz' && this.step === 0
    }
  }

  get isFormError(): boolean {
    const errors = {...this.errors}
    if(!this.isCorporate) {
      delete errors.corporateRegistrationNumber
    } else {
      delete errors.ownerName
      delete errors.ownerRegistrationNumber
      delete errors.bizPhoneNumber
      delete errors.ownerEmail
    }
    let error = false
    forEach(errors, (value) => {
      if(value) {
        error = true
        return false
      }
    })
    return error
  }

  get isCorporate() {
    const RRN_MAX_LENGTH = 10
    // 사업자등록번호의 가운데 2자리는 개인/법인 구분
    const CHECK_NUM_INDEX = 3
    const CHECK_NUM_LENGTH = 2
    // 81,82,83,84,85,86,87,88 에 속하면 법인
    const CORP_MIN_NUM = 81
    const CORP_MAX_NUM = 88
    const RRN = this.bizRegistrationNumber

    if(RRN.length !== RRN_MAX_LENGTH) {
      return false
    }
    const checkNum = Number(RRN.substring(CHECK_NUM_INDEX, CHECK_NUM_INDEX + CHECK_NUM_LENGTH))
    return checkNum >= CORP_MIN_NUM && checkNum <= CORP_MAX_NUM
  }

  get isDuplicatedBizRegistrationNumber() {
    return this.checkBizExistsStatus === 'failed'
  }

  get formModel() {
    return {
      name: this.name,
      bizRegistrationNumber: this.bizRegistrationNumber,
      corporateRegistrationNumber: this.corporateRegistrationNumber,
      ownerName: this.ownerName,
      isCorporate: this.isCorporate,
      ownerRegistrationNumber: this.ownerRegistrationNumber,
      bizPhoneNumber: this.bizPhoneNumber,
      ownerEmail: this.ownerEmail,
    }
  }

  openChannelTalk() {
    this.isDuplicatedBiz = false
    showChannelTalk()
  }

  closeDuplicationModal() {
    this.isDuplicatedBiz = false
    this.searchKeyword = ''
    this.onBack()
  }

  getLocalTime() {
    return DateTime.local().toISO({includeOffset: false})
  }

  getBizRegistrationError(value) {
    let result: any = null
    if(!value) {
      result = 'REQUIRED'
    } else if(!isBizRNum(value)) {
      result = 'INVALID'
    } else if(this.isDuplicatedBizRegistrationNumber) {
      result = 'DUPLICATED'
    }
    return result
  }

  isDuplicatedKeepBizError(error) {
    return error.response.status === 409
  }

  isDuplicatedMyBizError(error) {
    const {status, data={}} = error.response
    const isDuplicatedMyBizErrorStatus = '이미 해당 사업자 등록번호로 가입이 완료되었습니다.'
    const registrationNumberError = data.registrationNumber ? data.registrationNumber[0] : null
    return status === 400 && registrationNumberError === isDuplicatedMyBizErrorStatus
  }

  getRules(model: string) {
    const isEmptyFunction = (value: string) => {
      if(value.trim().length === 0) return 'empty'
      return null
    }
    if(model === 'name') {
      return isEmptyFunction
    } else if(model === 'ownerName') {
      return isEmptyFunction
    } else if(model === 'bizRegistrationNumber') {
      return this.getBizRegistrationError
    } else if(model === 'corporateRegistrationNumber') {
      return (value: string) => {
        if(!isCorpRNum(value)) return 'INVALID'
        return null
      }
    } else if(model === 'ownerRegistrationNumber') {
      return (value: string) => {
        if(!isPersonRNum(value)) return 'INVALID'
        return null
      }
    } else if(model === 'bizPhoneNumber') {
      return isEmptyFunction
    } else if(model === 'ownerEmail') {
      return isEmptyFunction
    }
  }

  getRulesMessage(model: string) {
    // 메시지 관리에 대한 정리 필요
    if(model === 'name') {
      return {
        'empty': '회사명을 입력해주세요.'
      }
    } else if(model === 'ownerName') {
      return {
        'empty': '대표자를 입력해주세요.'
      }
    } else if(model === 'bizRegistrationNumber') {
      return {
        'REQUIRED': '사업자 등록 번호를 입력해주세요.',
        'INVALID' : '사업자 등록 번호를 형식에 맞게 입력해주세요.',
        'DUPLICATED': '이미 등록된 사업자 등록 번호입니다.'
      }
    } else if(model === 'corporateRegistrationNumber') {
      return {
        'INVALID': '법인 등록 번호를 형식에 맞게 입력해주세요.'
      }
    } else if(model === 'ownerRegistrationNumber') {
      return {
        'INVALID': '대표자 주민등록번호를 형식에 맞게 입력해주세요.'
      }
    } else if(model === 'bizPhoneNumber') {
      return {
        'empty': '회사 대표 전화번호 (사업장 전화번호)를 입력해주세요.'
      }
    } else if(model === 'ownerEmail') {
      return {
        'empty': '대표자 이메일을 입력해주세요.'
      }
    }
  }

  validateField(model: string, valid: boolean) {
    this.validate[model] = valid

    if(this.isCorporate) {
      delete this.validate['ownerName']
      delete this.validate['ownerRegistrationNumber']
      delete this.validate['corporateRegistrationNumber']
    } else {
      delete this.validate['bizPhoneNumber']
      delete this.validate['ownerEmail']
    }
    
    const validMap = this.validate as Map<string, boolean>
    const validValues = values(validMap)
    this.doNext = validValues.filter((v) => !v).length === 0
  }

  onBack() {
    if(this.step === 0) {
      this.signOut()
      this.$router.push({name: 'sign-in'})
    }
    else this.step -= 1

    if(this.isCorporate) this.step = 0

    if(this.step === 1 && this.selectedCompany) {
      this.selectedCompany = null
      this.selectedIndex = null
    }
  }

  nextStep() {
    if(this.step > 1) {
      this.sending = true
      this.createBiz(this.formModel)
        .then(async () => {
          await this.getUser()
          if(this.type === 'create-biz') {
            this.sendCreateBizAmplitude()
          } else {
            this.sendSignUpBizAmplitude()
          }
          this.goToHome()
        })
        .catch((error) => {
          if(this.isDuplicatedMyBizError(error)) {
            this.isDuplicatedBiz = true
          } else if(this.isDuplicatedKeepBizError(error)) {
            this.sending = false
            this.updateError({
              id: 'create-biz',
              message: '이미 가입된 회사 정보입니다.',
            })
          } else {
            this.sending = false
            this.$sentry.withScope((scope) => {
              // PII 노출 방지: formModel에서 회사 식별 정보만 allow-list로 추려 sentry로 전송한다.
              // (대표자명/주민번호/대표 전화번호/대표자 이메일 등 신규 PII 필드가 추가되어도 기본 leak 안 됨)
              scope.setExtra('formData', pick(this.formModel, [
                'name',
                'bizRegistrationNumber',
                'corporateRegistrationNumber',
                'isCorporate',
              ]))
              scope.setExtra('step', this.step)
              scope.setExtra('error', error)
              this.$sentry.captureException(error)
            })
            this.updateError({
              id: 'create-biz',
              message: '회사 정보를 저장하는데 실패하였습니다.',
            })
          }
        })
    } else if(this.isCorporate && this.step === 0) {
      this.step += 2  // step 0 → step 2 (step 1 건너뜀)
    } else {
      this.step += 1
    }
  }

  filteredName(name: string) {
    const keyword = this.searchKeyword as string
    const nameArray = Array.from([...name])
    const html = nameArray.map((char) => {
      if(keyword.indexOf(char) > -1) {
        return `<span class='k-text-blue01'>${char}</span>`
      }
      return char
    })
    return html.join('')
  }

  /**
   * 공통 폼 채움. 검색 결과 선택, 직접입력, 외부 prefill에서 모두 사용.
   * 호출부가 step 진행/선택 상태 트래킹 등 부수효과를 별도로 책임진다.
   *
   * 비법인 분기에서 `userName`/`phone`/`email`을 fallback으로 사용하므로
   * 호출 시점에 auth state가 로드되어 있다고 가정한다 — sign-up-biz 라우트는
   * `authenticated` 미들웨어가 보장하므로 안전.
   * `company === null`이면 직접입력으로 간주(모든 필드 빈값 + 사용자 정보 fallback).
   */
  private _applyCompany(company: CompanyFormSeed | null) {
    this.name = company?.name || ''
    this.bizRegistrationNumber = company?.bizRegistrationNumber || ''
    if(this.isCorporate) {
      this.corporateRegistrationNumber = company?.corporateRegistrationNumber || ''
      this.ownerName = company?.ownerName || ''
    } else {
      this.ownerName = company?.ownerName || this.userName
      this.ownerRegistrationNumber = company?.ownerRegistrationNumber || ''
      this.bizPhoneNumber = company?.bizPhoneNumber || this.phone
      this.ownerEmail = this.email
    }
  }

  onSelectCompany(company, index) {
    this.selectedCompany = company
    this.selectedIndex = index
    this._applyCompany(company)
    this.nextStep()
  }

  onSearchCompany() {
    // const form = this.$refs.formData as any
    // form.validateField('searchKeyword')

    if(!this.searchKeyword) {
      return
    }
    this.loading = true
    this.searchCompanies(this.searchKeyword)
      .then(() => {
        const inputEl: any = this.$refs['search-input']
        if(inputEl) {
          inputEl.blur()
        }
        this.searchCompanyStatus = this.companies.length === 0 ? 'empty' : 'success'
      })

    this.loading = false
  }

  searchCompanies(name) {
    this.loading = true
    return this.getCompanies({name})
      .catch((error) => {
        this.$sentry.withScope((scope) => {
          scope.setExtra('data', {
            name: name,
          })
          scope.setExtra('error', error)
          this.$sentry.captureException(new Error('Failed to search company.'))
        })
        return error
      })
      .finally(() => {
        this.loading = false
      })
  }

  sendCreateBizAmplitude() {
    this.logEventWithGroups({
      eventType: 'create_biz',
    })

    this.setBizProperty({
      event: 'setOnceBizProperty',
      bizProperty: {'biz_register_date': this.getLocalTime()}
    })
  }

  sendSignUpBizAmplitude() {
    this.logEventWithGroups({
      eventType: 'complete',
      eventProperties: {
        'biz_entity': this.isCorporate ? 'corporate' : 'private',
        'complete_type': 'success',
        'workflow': 'sign_up',
      }
    })
    this.setBizProperty({
      event: 'setOnceBizProperty',
      bizProperty: {'sign_up_date': this.getLocalTime()}
    })
    this.setUserProperty({
      event: 'addUserProperty',
      userProperty: {'company_count': this.bizs.length}
    })
  }

  goToHome() {
    this.$router
      .replace({name: 'home', params: {bizId: this.bizId}})
      .catch((err) => err)
  }

  created() {
    // 1회용으로 사용하기 위해 읽은 직후 삭제한다. (다른 경로 재방문 시 옛 값이 prefill되는 것을 방지)
    const prefillCompanyName = localStorage.getItem('company_name')
    const prefillBizNumber = localStorage.getItem('business_number')
    localStorage.removeItem('company_name')
    localStorage.removeItem('business_number')
    // 외부 제휴사 배너 유입 prefill은 회원가입(/sign-up/biz)에서만 적용한다.
    // 기존 사용자의 회사 추가(/create-biz)에서는 prefill하지 않는다.
    if(this.$route.name !== 'sign-up-biz') return
    if(isBizRNum(prefillBizNumber)) {
      // _applyCompany + nextStep으로 사용자 정보 자동완성과 법인/개인 step 분기를 적용한다.
      // selectedCompany는 사용자 선택의 추적용이므로 자동 prefill에서는 건드리지 않는다.
      this._applyCompany({
        name: prefillCompanyName || '',
        bizRegistrationNumber: prefillBizNumber,
      })
      this.nextStep()
    } else if(prefillCompanyName) {
      this.searchKeyword = prefillCompanyName
    }
  }

  mounted() {
    this.clearCompanies()
  }
}
